<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import TransactionAPI from '../constants/transaction.api.uri.const'
import { formatTableDataTransaction } from '../helper/table'
import ColorCell from '@/onenetwork/components/datatable/ColorCell.vue'
import { orderBy } from 'lodash'

interface Props {
  account: any,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
interface DataSource {
  list: any[];
  totalPage: number;
  totalRecords: number;
}

const dataSource = ref<DataSource>({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (newPage: number) => {

  page.value = newPage;
  requestFetchData()
}

const handleChangePageSize = (size: number) => {

  pageSize.value = size
  requestFetchData()
}

const requestFetchData = async () => {
  try{
    const res = await APIClient.get(TransactionAPI.transactions.list, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        user_id: props.account?.id,
        sort: ['created_at', 'desc'],
        order_by: 'created_at',
        order_dir: 'desc',
      }
    });

    const { data } = res.data;
    if (res.data.code === 200) {
      dataSource.value = {
        list: formatTableDataTransaction(data.data) || [],
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }
  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '8') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        transaction_date: { label: 'Thời gian giao dịch', component: DateTimeCell, visible: true, class: 'w-[150px]', sort: false, config: {} },
        balance_type: { label: 'Loại ví', component: TextCell, visible: true, class: 'w-[150px]', sort: false, config: {} },
        transaction_code: { label: 'Mã giao dịch', component: TextCell, visible: true, class: 'w-[150px]', sort: false, config: {} },
        transaction_type: { label: 'Loại giao dịch', component: ColorCell, visible: true, class: 'w-[150px]', sort: false, config: {} },
        amount: { label: 'Số tiền', component: MoneyCell, visible: true, sort: false, class: 'w-[150px] justify-end', config: {} },
        description: { label: 'Nội dung giao dịch', component: TextCell, visible: true, sort: false, config: {} },
      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
